// ----------------------------------------------------------------------

export default function Typography(theme) {
    return {
        MuiTypography: {
            styleOverrides: {
                body1: {
                    color: theme.palette.text.default,
                    fontWeight: 600
                },
                subtitle1: {
                    color: theme.palette.text.default,
                },
                subtitle2: {
                    color: theme.palette.text.disabled,

                },
                paragraph: {
                    marginBottom: theme.spacing(2),
                },
                gutterBottom: {
                    marginBottom: theme.spacing(1),
                },
            },
        },
    };
}
